var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "preview-card", class: _vm.classObject }, [
    _c("div", {
      staticClass: "preview-card__img",
      style: "background-image: url(" + _vm.image + ");",
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "preview-card__preview" },
      [
        _vm.title
          ? _c(
              "z-caption",
              {
                staticClass: "white-text u-collapse--all",
                attrs: { size: "l" },
              },
              [_c("span", { domProps: { innerHTML: _vm._s(_vm.title) } })]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "preview-card__detail" }, [_vm._t("detail")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }